import React, { useState, useEffect } from "react";
import axios from "axios";
import AdminTopNavBar from "./AdminTopNavBar";
import AdminSideBar from "./AdminSideBar";
import { Outlet } from "react-router-dom";
import { api_url } from "../config/config";

const AdminDashboard = () => {
  const [activeItem, setActiveItem] = useState("Profile");
  const token = localStorage.getItem("admin_token");
  const [userData, setUserData] = useState(null);
  const [access, setAccess] = useState("admin");

  const handleNavigation = (item) => {
    setActiveItem(item);
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axios.get(`${api_url}/admin`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        },
      });
      setUserData(data.data);
      setAccess(data.data.role);
    } catch (e) {
      console.error("Error fetching profile", e);
    }
  };

  useEffect(() => {
    if (token) {
      fetchProfile();
    }
  }, [token]);

  return (
    <div className="flex h-screen">
      <AdminSideBar
        activeItem={activeItem}
        handleNavigation={handleNavigation}
        accessRole={access}
      />
      <div className="flex overflow-x-hidden flex-col w-full">
        <div className="flex w-full z-50 flex-1 fixed top-0 pl-48">
          <AdminTopNavBar userData={userData} />
        </div>
        <div className="flex-grow bg-gray-100 p-8 mt-10 pl-52">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;